import {
  SEARCH_CLIENT_PANEL,
  SEARCH_CLIENT_PANEL_SUCCESS,
  SEARCH_CLIENT_PANEL_ERROR,
  SEARCH_CLIENT_PANEL_EMPTY,
} from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const SearchClientPanel = (state = initialState, action) => {
  switch (action.type) {
    case SEARCH_CLIENT_PANEL:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case SEARCH_CLIENT_PANEL_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };

      break;

    case SEARCH_CLIENT_PANEL_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case SEARCH_CLIENT_PANEL_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default SearchClientPanel;
